import { render, staticRenderFns } from "./UsersInfo.vue?vue&type=template&id=940cf5ee&scoped=true"
import script from "./UsersInfo.vue?vue&type=script&lang=js"
export * from "./UsersInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "940cf5ee",
  null
  
)

export default component.exports